/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_violin_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With a Gaussian kernel density estimate using Silverman's rule-of-thumb bandwidth, the standard default used by most statistical software.`)
};

const es_violin_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con una estimación de densidad de kernel gaussiano usando la regla empírica de ancho de banda de Silverman, el valor predeterminado estándar utilizado por la mayoría del software estadístico.`)
};

const de_violin_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit einer Gauß-Kerndichteschätzung unter Verwendung von Silvermans Faustregel für die Bandbreite, dem in den meisten Statistikprogrammen üblichen Standardwert.`)
};

const nl_violin_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Met een Gaussiaanse kerndichtheidsschatting met Silvermans vuistregel voor de bandbreedte, de standaardinstelling die door de meeste statistische software wordt gebruikt.`)
};

const fr_violin_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avec une estimation de densité par noyau gaussien utilisant la règle empirique de bande passante de Silverman, la valeur par défaut standard utilisée par la plupart des logiciels statistiques.`)
};

const it_violin_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con una stima di densità kernel gaussiana usando la larghezza di banda della regola pratica di Silverman, il valore predefinito standard usato dalla maggior parte dei software statistici.`)
};

const pt_br2_violin_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com uma estimativa de densidade de kernel gaussiano usando a largura de banda pela regra prática de Silverman, o padrão default usado pela maioria dos softwares estatísticos.`)
};

const pt_violin_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com uma estimativa de densidade por kernel gaussiano, usando a largura de banda pela regra prática de Silverman, o padrão predefinido utilizado pela maioria do software estatístico.`)
};

const ja_violin_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ほとんどの統計ソフトウェアで標準的に使われるデフォルト手法である、Silvermanの経験則による帯域幅を用いたガウスカーネル密度推定によって計算されます。`)
};

const zh_violin_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用高斯核密度估计，并采用 Silverman 经验带宽规则，这是大多数统计软件使用的标准默认方法。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const violin_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.violin_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("violin_faq_a3", locale)
	if (locale === "en") return en_violin_faq_a3(inputs)
	if (locale === "es") return es_violin_faq_a3(inputs)
	if (locale === "de") return de_violin_faq_a3(inputs)
	if (locale === "nl") return nl_violin_faq_a3(inputs)
	if (locale === "fr") return fr_violin_faq_a3(inputs)
	if (locale === "it") return it_violin_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_violin_faq_a3(inputs)
	if (locale === "pt") return pt_violin_faq_a3(inputs)
	if (locale === "ja") return ja_violin_faq_a3(inputs)
	return zh_violin_faq_a3(inputs)
};